import type { InfoBarMessageSource } from 'owa-info-bar';
import { logUsage } from 'owa-analytics';

export function logProposedNewTimeInfobarClicked(source: InfoBarMessageSource) {
    logUsage('ProposedNewTimeInfobarClicked', [source]);
}

export function logCurrentTimeInfobarClicked(source: InfoBarMessageSource) {
    logUsage('CurrentTimeInfobarClicked', [source]);
}
